<header class="site-header">
  <a class="brand" href="/" aria-label="Widely home">WIDELY</a>
  <nav aria-label="Primary navigation">
    <a href="/#features">Features</a>
    <a href="/business-card-scanner">Scanner</a>
    <a href="/resources">Resources</a>
    <a href="/support">Support</a>
    <a class="download" href="/#download">Download</a>
  </nav>
</header>

<style>
  .site-header{position:relative;z-index:10;display:flex;width:min(100% - 40px,1240px);min-height:88px;margin:auto;align-items:center;justify-content:space-between;gap:24px;border-bottom:1px solid #262628}
  .brand{color:#f7f7f3;font-size:1.08rem;font-weight:800;letter-spacing:.32em;text-decoration:none}
  nav{display:flex;align-items:center;gap:clamp(14px,2.7vw,36px)}
  nav a{display:inline-flex;min-height:44px;align-items:center;color:#999995;font-size:.88rem;text-decoration:none}
  nav a:hover{color:#f7f7f3}
  nav .download{padding:0 17px;border:1px solid #404043;color:#f7f7f3}
  @media(max-width:640px){.site-header{width:calc(100% - 32px);min-height:72px;align-items:flex-start;flex-direction:column;padding:22px 0 15px}nav{width:100%;gap:8px;overflow-x:auto;scrollbar-width:none}nav::-webkit-scrollbar{display:none}nav a{flex:0 0 auto;padding:0 9px}nav a:first-child{padding-left:0}}
</style>
